import React from 'react';
import axios from 'axios';
import { Alert, Spin, Tabs } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import DataUploadForm from '../components/DataUploadForm';
import OnboardingWizard from '../components/OnboardingWizard';
import * as serverconfig from '../serverconn';
import { INSTITUTION_TERMS } from '../institutionCopy';

var CryptoJS = require('crypto-js');

const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { TabPane } = Tabs;

var sacco = '';

class OnboardingSectionView extends React.Component {
  state = {
    datarequested: true,
    companyprofile: {},
    onboardingProgress: null,
  };

  componentDidMount() {
    if (localStorage.getItem('sacco')) {
      sacco = CryptoJS.AES.decrypt(localStorage.getItem('sacco'), 'my-secret-key@12345').toString(CryptoJS.enc.Utf8);
    } else {
      sacco = '';
    }

    const token = localStorage.getItem('token') || '';
    axios.defaults.headers = {
      'Content-Type': 'application/json',
      Authorization: `Token ${token}`,
    };

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`).then((res) => {
      this.setState({
        companyprofile: res.data,
        datarequested: false,
      });
    });
  }

  handleProgressChange = (progress) => {
    this.setState({
      onboardingProgress: progress,
      companyprofile: {
        ...this.state.companyprofile,
        client_onboarding_done: progress.client_onboarding_done,
      },
    });
  };

  render() {
    if (this.state.datarequested === true) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Spin indicator={antIcon} />
        </div>
      );
    }

    const onboardingDone = this.state.companyprofile.client_onboarding_done === true;

    return (
      <div>
        {onboardingDone && (
          <Alert
            type="success"
            showIcon
            message={`${INSTITUTION_TERMS.dataOnboarding} is complete`}
            description="Use the Advanced uploads tab for operational imports, or reopen the guided wizard from the Finish step."
            style={{ marginBottom: 16 }}
          />
        )}

        <Tabs defaultActiveKey="wizard">
          <TabPane tab="Guided wizard" key="wizard">
            <OnboardingWizard onProgressChange={this.handleProgressChange} />
          </TabPane>

          <TabPane tab="Advanced uploads" key="advanced">
            <Alert
              type="info"
              showIcon
              message="All upload types in one place"
              description="Use this when you know exactly which template you need. For first-time setup, prefer the Guided wizard tab."
              style={{ marginBottom: 16 }}
            />
            <DataUploadForm />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default OnboardingSectionView;
